// Endpoint resolution for the job description writer client. Both employer (web SPA +
// mobile-shaped REST) and admin (dashboard, session-auth) surfaces consume
// the same React modal; only the base path differs.

export const EMPLOYER_DIDE_WRITER_ENDPOINT = '/api/v1/employer/ai/job_descriptions';
export const ADMIN_DIDE_WRITER_ENDPOINT = '/admin/ai/job_descriptions';

export type DideWriterEndpointBase =
  | typeof EMPLOYER_DIDE_WRITER_ENDPOINT
  | typeof ADMIN_DIDE_WRITER_ENDPOINT
  | string; // allow custom in tests

export const generateUrl = (base: DideWriterEndpointBase = EMPLOYER_DIDE_WRITER_ENDPOINT): string => base;

export const feedbackUrl = (
  draftId: number,
  base: DideWriterEndpointBase = EMPLOYER_DIDE_WRITER_ENDPOINT
): string => `${base}/${draftId}/feedback`;
